import * as firebase from 'firebase'

export default {
  state: {
    loadedEnrollments: [
      {
        enrollmentId: 'tri',
        enrollmentName: 'Enrollment Sample',
        enrollmentPriority: '0'
      }
    ]
  },
  mutations: {
    setLoadedEnrollments (state, payload) {
      state.loadedEnrollments = payload
    },
    createEnrollment (state, payload) {
      state.loadedEnrollments.push(payload)
    },
    updateEnrollment (state, payload) {
      const enrollment = state.loadedEnrollments.find(enrollment => {
        return enrollment.enrollmentId === payload.enrollmentId
      })
      if (payload.enrollmentName) {
        enrollment.enrollmentName = payload.enrollmentName
      }
      if (payload.enrollmentPriority) {
        enrollment.enrollmentPriority = payload.enrollmentPriority
      }
    },
    deleteEnrollment (state, payload) {
      const enrollment = state.loadedEnrollments.find(function (enrollment) {
        return enrollment.enrollmentId === payload.enrollmentId
      })
      var todos = state.loadedEnrollments
      todos.splice(todos.indexOf(enrollment), 1)
    }
  },
  actions: {
    loadEnrollments ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('enrollments').once('value')
        .then((data) => {
          const enrollments = []
          const obj = data.val()
          for (let key in obj) {
            enrollments.push({
              enrollmentId: key,
              enrollmentName: obj[key].enrollmentName,
              enrollmentPriority: obj[key].enrollmentPriority,
              creatorId: obj[key].creatorId
            })
          }
          console.log(enrollments)
          commit('setLoadedEnrollments', enrollments)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createEnrollment ({commit, getters}, payload) {
      const enrollment = {
        enrollmentName: payload.title,
        enrollmentPriority: payload.enrollmentPriority,
        // enrollmentId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'enrollment_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('enrollments').push(enrollment)
        .then(() => {
          commit('createEnrollment', {
            ...enrollment
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createEnrollment', enrollment)
    },
    // May have to create a separate Action for each updated item (i.e. updateEnrollmentEnrollment, updateEnrollmentDescription, etc)
    updateEnrollmentData ({commit}, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.enrollmentName) {
        updateObj.enrollmentName = payload.enrollmentName
      }
      if (payload.enrollmentPriority) {
        updateObj.enrollmentPriority = payload.enrollmentPriority
      }
      firebase.database().ref('enrollments').child(payload.enrollmentId).update(updateObj)
      .then(() => {
        commit('setLoading', false)
        commit('updateEnrollment', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    },
    deleteEnrollmentData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('enrollments').child(payload.enrollmentId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteEnrollment', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedEnrollments (state) {
      return state.loadedEnrollments.sort((enrollmentA, enrollmentB) => {
        return enrollmentA.enrollmentPriority > enrollmentB.enrollmentPriority
      })
    },
    featuredEnrollments (state, getters) {
      return getters.loadedEnrollments.slice(0, 5)
    },
    loadedEnrollment (state) {
      return (someId) => {
        return state.loadedEnrollments.find((enrollment) => {
          return enrollment.enrollmentId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/enrollment/index.js